import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusSecondAvisPatient'
})
export class StatusSecondAvisPatientPipe implements PipeTransform {

  transform(status:String, language: 'fr' | 'ar' = 'fr'): unknown {
    switch (status) {
      case 'REQUESTED':
        return  language === 'fr' ? 'Demande envoyée' : 'تم إرسال الطلب';
      case 'VERIFIED':
        return language === 'fr' ? 'Demande vérifiée' : 'تم التحقق من الطلب';
      case 'SUBMITTED':
        return language === 'fr' ? 'Demande Envoyée au médecin' : 'تم إرساله إلى الطبيب';
      case 'ACCEPTED':
        return language === 'fr' ? 'Demande acceptée' : 'تم قبول الطلب';
      case 'PROCESSING':
        return language === 'fr' ? 'Demande en cours de traitement' : 'قيد المعالجة';
      case 'COMPLETED':
        return language === 'fr' ? 'Demande complétée' : 'التقرير جاهز';
      default:
        return status;
    }
  }

}
